import router from "../../router/route.js";
import routers from "../../router/index.js";
import MenuUtils from "../../utils/MenuUtils";

export default {
  state: {
    menuTree: [],//tab渲染路由
    routerMenuTree: router,//全部路由
    activeIndex: null,
    roleType: null
  },
  mutations: {
    setMenuTree(state, menuTree) {
      //一级对比过滤         
      let _menuTree = [] //menuTree传过来的路由
      let _defaultRoutes = state.routerMenuTree[0].children;  //写的的全部路由     
      for (let i = 0; i < _defaultRoutes.length; i++) {
        for (let j = 0; j < menuTree.length; j++) {
          if (_defaultRoutes[i].path == menuTree[j].url) {            
            _defaultRoutes[i].id = menuTree[j].id;
            _menuTree.push(_defaultRoutes[i]);           
          }
                   
        }
      }
      console.log(_menuTree, '_menuTree');
      console.log(state.roleType, 'state.roleType');

      //进行menuTree的二级权限过滤
      let _menuTreeChildren = [];
      _menuTree.forEach((value, index) => {
        _menuTreeChildren[index] = value;
        _menuTreeChildren[index].children = value.children.filter(item => {
          if (item.meta.customerType) {
            return item.meta.customerType.indexOf(String(state.roleType)) != -1;
          }
        });
      });
      state.routerMenuTree[0].children = _menuTreeChildren      
      let datas = [];
      MenuUtils(datas, state.routerMenuTree );
      routers.addRoutes(datas);
      state.menuTree = state.routerMenuTree[0].children
    },
    setActiveIndex(state, activeIndex) {
      state.activeIndex = activeIndex
    },
    setRoleType(state, roleType) {
      state.roleType = roleType
    },
  },

}



// WEBPACK FOOTER //
// ./src/store/menuTree/index.js